import { createSlice } from '@reduxjs/toolkit';
import { NewsSchema } from '../types/newsSchema';
import { fetchListNews } from '@entities/News/module/services/fetchListNews';

const initialState: NewsSchema = {
  news: [],
  isLoaded: false,
};

export const newsSlice = createSlice({
  name: 'news',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: builder => {
    builder.addCase(fetchListNews.fulfilled, (state, action) => {
      if (action.payload) {
        state.news = Object.values(action.payload).flat();
      }
      state.isLoaded = true;
    });
  },
});

export const { actions: newsActions } = newsSlice;
